import {
  string as yupString,
} from 'yup';

import InputFormik from '../../shared/forms/input/inputFormik.component';
import SelectFormik from '../../shared/forms/select/sdkSelectFormik.component';
import { required, maxLength, oneOfExisting, nullable } from '../../shared/forms/validators';
import { YesNoFlag } from '../../shared/types';

const getSchema = categoryToEdit => [
  {
    name: 'categoryName',
    component: InputFormik,
    meta: { label: 'Name' },
    options: { disabledWhenEditing: true, yupType: yupString(), validationRules: [required, maxLength(50)] },
    additionalProps: { required: true },
  },
  {
    name: 'description',
    component: InputFormik,
    meta: { label: 'Description' },
    options: { yupType: yupString(), validationRules: [required, maxLength(50)] },
    additionalProps: { required: true },
  },
  {
    name: 'catView',
    component: SelectFormik,
    meta: { label: 'Cat View', optionsKey: 'catViewOptions' },
    options: { yupType: yupString(), validationRules: [required] },
    additionalProps: { required: true },
  },
  {
    name: 'defaultTag',
    component: SelectFormik,
    meta: { label: 'Default Tag', optionsKey: 'defaultTagOptions' },
    options: {
      yupType: yupString(),
      validationRules: categoryToEdit?.requiresDefaultTag === YesNoFlag.N
        ? [nullable]
        : [],
    },
    additionalProps: categoryToEdit?.requiresDefaultTag === YesNoFlag.N
      ? { clearable: true }
      : {},
  },
  {
    name: 'subCategoryName',
    component: SelectFormik,
    meta: { label: 'Sub Category Name', optionsKey: 'categoriesOptions' },
    options: { yupType: yupString(), validationRules: [nullable, oneOfExisting('categoriesOptions')] },
    additionalProps: { clearable: true, virtualized: true },
  },
];

export default getSchema;
